export const simulationStatusActions = {
  CANCEL: 'CANCEL',
  DELETE: 'DELETE'
}
